import { MutationTree } from 'vuex';
import { ActionStatus } from '@/application/types';
import { Project, ProjectSearchState } from '../types';
import { projectSearchStateDefaults } from './defaults';

export const projectSearchMutations: MutationTree<ProjectSearchState> = {

  clear(state) {
    state.hasSearchBeenTriggered = projectSearchStateDefaults.hasSearchBeenTriggered;
    state.hasSearchResultedIn0Results = projectSearchStateDefaults.hasSearchResultedIn0Results;
    state.lastSearchTerm = projectSearchStateDefaults.lastSearchTerm;
    state.projects = [];
    state.getProjectsByBaseProjectNumberStatus = ActionStatus.None;
  },

  // Update search term
  updateLastSearchTerm(state, searchTerm: string) {
    state.lastSearchTerm = searchTerm;
  },

  // Get product identifications by EAN

  getProjectsByBaseProjectNumberStarted(state) {
    state.getProjectsByBaseProjectNumberStatus = ActionStatus.InProgress;
  },

  getProjectsByBaseProjectNumberSucceeded(state, projects: Project[]) {
    state.projects = projects;
    state.hasSearchBeenTriggered = true;
    state.hasSearchResultedIn0Results = projects.length === 0;
    state.getProjectsByBaseProjectNumberStatus = ActionStatus.Successful;
  },

  getProjectsByBaseProjectNumberFailed(state) {
    state.getProjectsByBaseProjectNumberStatus = ActionStatus.Failed;
  },

};
